<template>
  <v-row>

    <!-- Sélecteurs de date -->
    <v-col cols="12" md="6">
      <v-menu v-model="startMenu" :close-on-content-click="false">
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="startDate"
            label="Date de début"
            prepend-icon="mdi-calendar"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="startDate" @input="startMenu = false"></v-date-picker>
      </v-menu>
    </v-col>

    <v-col cols="12" md="6">
      <v-menu v-model="endMenu" :close-on-content-click="false">
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="endDate"
            label="Date de fin"
            prepend-icon="mdi-calendar"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="endDate" @input="endMenu = false"></v-date-picker>
      </v-menu>
    </v-col>

    <!-- Carte récapitulative -->
    <v-col cols="12">
      <v-card class="pa-4" color="grey darken-3" dark>
        <v-row class="text-center">
          <!-- Total Paiements -->
          <v-col cols="12" sm="4" class="metric-item">
            <div class="d-flex flex-column align-center">
              <v-icon large class="mb-2">mdi-cash-multiple</v-icon>
              <div class="text-subtitle-1">Total Paiements</div>
              <div class="text-h5 font-weight-bold">{{ total_payments }} FCFA</div>
            </div>
          </v-col>

          <!-- Commissions -->
          <v-col cols="12" sm="4" class="metric-item">
            <div class="d-flex flex-column align-center">
              <v-icon large class="mb-2">mdi-percent</v-icon>
              <div class="text-subtitle-1">Commissions</div>
              <div class="text-h5 font-weight-bold red--text">{{ total_commissions }} FCFA</div>
            </div>
          </v-col>

          <!-- Solde Net -->
          <v-col cols="12" sm="4" class="metric-item">
            <div class="d-flex flex-column align-center">
              <v-icon large class="mb-2">mdi-scale-balance</v-icon>
              <div class="text-subtitle-1">Solde Net</div>
              <div class="text-h5 font-weight-bold green--text">{{ net_balance }} FCFA</div>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-col>


    <!-- Tableau des transactions -->
    <v-col cols="12">
      <v-data-table
        :headers="headers"
        :items="sortedTransactions"
        :items-per-page="10"
        class="elevation-1"
      >
        <!-- En-tête avec icône calendrier -->
        <template #[`header.date`]>
          <div class="d-flex align-center">
            <v-icon small class="mr-1">mdi-calendar</v-icon>
            Date
          </div>
        </template>

        <!-- Cellule avec icône calendrier -->
        <template #[`item.date`]="{ item }">
          <div class="d-flex align-center">
            <v-icon small class="mr-2">mdi-calendar</v-icon>
            {{ item.date }}
          </div>
        </template>

        <template #[`item.amount`]="{ item }">
          <v-chip v-if="item.amount > 0" class="green--text">
            {{ item.amount }} FCFA
          </v-chip>
          <span v-else>-</span>

        </template>
            <template #[`item.commission`]="{ item }">
                <v-chip
                  class="green--text"
                  style="color: red;"
                >
                  -{{ item.commission || 0 }} FCFA
                </v-chip>
              </template>


        <template #[`item.net_amount`]="{ item }">
          <span class="green--text">{{ item.net_amount }} FCFA</span>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      sortBy: 'date',
      sortDesc: true,
      startDate: null,
      endDate: null,
      startMenu: false,
      endMenu: false,
      headers: [
        { text: 'Utilisateur', value: 'username' },
        { text: 'Montant Total', value: 'amount' },
        { text: 'Commission (55%)', value: 'commission' },
        { text: 'Montant Net', value: 'net_amount' },
        { text: 'Date', value: 'date' },
        { text: 'Méthode', value: 'payment_method' }
      ],
      transactions: [],
      total_payments: 0,
      total_commissions: 0,
      net_balance: 0,
      summaryCards: [
        { title: 'Total Paiements', value: 0, color: 'blue-grey darken-1' },
        { title: 'Commissions', value: 0, color: 'deep-orange darken-2' },
        { title: 'Solde Net', value: 0, color: 'green darken-2' }
      ]
    }
  },
  watch: {
    startDate() {
      this.fetchBusinessTransactions()
    },
    endDate() {
      this.fetchBusinessTransactions()
    },
  },

  computed: {
    sortedTransactions() {
      return [...this.transactions].sort((a, b) => {
        const dateA = new Date(a.date)
        const dateB = new Date(b.date)
        return this.sortDesc ? dateB - dateA : dateA - dateB
      })
    }
  },

  async mounted() {
    await this.fetchBusinessTransactions()
  },

  methods: {
    async fetchBusinessTransactions() {
      try {
        const params = {
          start_date: this.startDate,
          end_date: this.endDate
        }

        const response = await axios.get('/api/v1/manager/business/transactions/', { params })
        this.transactions = response.data.transactions
        this.total_payments = response.data.total_payments
        this.total_commissions = response.data.total_commissions
        this.net_balance = response.data.net_balance

        // Mise à jour des cartes récapitulatives
        this.summaryCards = [
          { title: 'Total Paiements', value: this.total_payments, color: 'blue-grey darken-1' },
          { title: 'Commissions', value: this.total_commissions, color: 'deep-orange darken-2' },
          { title: 'Solde Net', value: this.net_balance, color: 'green darken-2' }
        ]
      } catch (error) {
        console.error('Erreur lors de la récupération des transactions:', error)
        this.$store.commit('setSnackBarMessage', "Erreur de connexion au serveur")
        this.$store.commit('setSnackBarColor', "error")
        this.$store.commit('activateSnackBar', true)
      }
    }
  }
}
</script>

<style scoped>
.metric-item {
  border-right: white;
  min-height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.metric-item:last-child {
  border-right: none;
}

@media (max-width: 600px) {
  .metric-item {
    border-right: none;
    border-bottom: white;
    padding: 1rem 0;
    min-height: auto;
  }

  .metric-item:last-child {
    border-bottom: none;
  }

  .text-subtitle-1 {
    font-size: 0.875rem !important;
  }

  .text-h5 {
    font-size: 1.25rem !important;
  }
}
</style>
